module.exports = __webpack_public_path__ + "static/media/swift_charts.1aaafe23.png";